const COOKING_VERBS = [
  'bake',
  'boil',
  'broil',
  'chill',
  'cook',
  'fry',
  'grill',
  'marinate',
  'roast',
  'rest',
  'saute',
  'sauté',
  'sear',
  'simmer',
  'steam',
]

function splitInstructionText(text) {
  const clean = String(text || '').trim()
  if (!clean) return []
  const byLines = clean.split(/\n+/).map((line) => line.trim()).filter(Boolean)
  if (byLines.length > 1) return byLines.map((line) => line.replace(/^\d+[).\s-]+/, '').trim()).filter(Boolean)

  const byNumbers = clean.split(/\s+(?=\d+[).]\s+)/).map((part) => part.replace(/^\d+[).]\s*/, '').trim()).filter(Boolean)
  return byNumbers.length > 1 ? byNumbers : [clean]
}

function textFromInstruction(raw) {
  if (raw == null) return ''
  if (typeof raw === 'string') return raw.trim()
  if (typeof raw !== 'object') return String(raw).trim()
  return String(
    raw.text
    || raw.instruction
    || raw.name
    || raw.description
    || raw.step
    || ''
  ).trim()
}

function inferTimer(text) {
  const lower = text.toLowerCase()
  const match = lower.match(/\b(?:for\s+)?(\d{1,3})\s*(?:to|-)\s*(\d{1,3})\s*(minutes?|mins?|hours?|hrs?)\b|\b(?:for\s+)?(\d{1,3})\s*(minutes?|mins?|hours?|hrs?)\b/)
  if (!match) return null
  const softWindow = lower.slice(Math.max(0, match.index - 16), match.index)
  if (/\b(about|approx|approximately|around)\b/.test(softWindow)) return null
  const amount = Number(match[2] || match[4])
  const unit = String(match[3] || match[5] || '').toLowerCase()
  if (!Number.isFinite(amount) || amount <= 0) return null
  const minutes = unit.startsWith('hour') || unit.startsWith('hr') ? amount * 60 : amount
  const verb = COOKING_VERBS.find((candidate) => lower.includes(candidate)) || 'Timer'
  return { label: verb.charAt(0).toUpperCase() + verb.slice(1), minutes }
}

function inferHint(text) {
  const lower = text.toLowerCase()
  const match = text.match(/\b(?:about|approx\.?|approximately|around)\s+\d{1,3}\s*(?:minutes?|mins?|hours?|hrs?)\b/i)
  if (match) return match[0]
  const untilIndex = lower.indexOf('until ')
  if (untilIndex >= 0) return text.slice(untilIndex).replace(/[.;]\s*$/, '').trim()
  return null
}

export function normalizeRecipeMethod(metadata = {}) {
  const meta = metadata && typeof metadata === 'object' ? metadata : {}
  const raw = meta.cook_steps
    || meta.method
    || meta.instructions
    || meta.recipeInstructions
    || meta.raw_metadata?.recipeInstructions
    || meta.raw_metadata?.instructions

  const rawSteps = Array.isArray(raw) ? raw : splitInstructionText(raw)
  return rawSteps
    .map((textOrStep) => {
      const text = textFromInstruction(textOrStep)
      if (!text) return null
      const source = typeof textOrStep === 'object' && textOrStep !== null ? textOrStep : {}
      const explicitTimer = source.timer && Number(source.timer.minutes) > 0
        ? source.timer
        : null
      return {
        text,
        hint: source.hint || inferHint(text) || undefined,
        timer: explicitTimer || inferTimer(text) || undefined,
        phase: source.phase || undefined,
        sourceStepIndex: source.source_step_index || undefined,
      }
    })
    .filter(Boolean)
}
